import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Box, Typography } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ vehicleConsignmentStats, colors, totalAmountVehicles }: any) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        hoverBackgroundColor: [],
        borderWidth: 0,
      },
    ],
  });

  const options = {
    responsive: true,
    cutout: "80%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  useEffect(() => {
    if (vehicleConsignmentStats) {
      setData({
        labels: vehicleConsignmentStats.map((item: any) => item.consignmentType),
        datasets: [
          {
            data: vehicleConsignmentStats.map((item: any) => item.count),
            backgroundColor: colors,
            hoverBackgroundColor: colors,
            borderWidth: 0,
          },
        ],
      });
    }
  }, [vehicleConsignmentStats, colors]);

  const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
  const percentages = data.datasets[0].data.map((value) => ((value / total) * 100).toFixed(1));

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box style={{ position: "relative", width: "50%", margin: "auto" }}>
        <Doughnut data={data} options={options} />
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" component="p">
            {totalAmountVehicles}
          </Typography>
          <Typography variant="body1" component="p">
            Vehicles
          </Typography>
        </Box>
      </Box>
      <Box mt={4} height={220} overflow="auto" width="100%">
        {data.labels.map((label, index) => (
          <Box key={index} display="flex" alignItems="center" mb={1}>
            <Box
              style={{
                width: "16px",
                height: "16px",
                backgroundColor: data.datasets[0].backgroundColor[index],
                marginRight: "8px",
              }}
            />
            <Typography variant="body1" component="p" style={{ flexGrow: 1 }}>
              {label}
            </Typography>
            <Typography variant="body1" component="p">
              {data.datasets[0].data[index]} ({percentages[index]}%)
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DoughnutChart;
